import brand from "../../assets/images/brand/Tensolite-Isologotipo-con-bajada.svg";
import brandV from "../../assets/images/brand/Tensolite-Isologotipo-vertical.svg";
import ProductLiNav from '../products/ProductLiNav';
import Offcanvas from "react-bootstrap/Offcanvas";
import { Navbar } from "react-bootstrap";
import { sortAndFilterProducts } from '../../helpers/functions';
import { PRODUCTO_ESPECIAL, PRODUCTO_LINEA } from '../../helpers/constants';
import useProduct from "../../hooks/useProduct";
import { useState } from "react";
import Spinner from 'react-bootstrap/Spinner';

function OffcanvasProducts({ show, handleClose }) {
  const { products, getAllProducts, loading } = useProduct();
  const [productsFetch, setProductsFetch] = useState(false);

  if (show && !productsFetch) {
    getAllProducts({ onlyTitleAndIcon: true, visible: true });
    setProductsFetch(true);
  }

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      id="header-nav-producto"
    >
      <Offcanvas.Header closeButton>
        <Navbar.Brand className="desk" href="/">
          <img src={brand} alt="Logo de Tensolite" />
        </Navbar.Brand>
        <Navbar.Brand className="mobil" href="/">
          <img
            src={brandV}
            alt="Logo de Tensolite"
            className=" logo-mobil"
          />
        </Navbar.Brand>
      </Offcanvas.Header>
      {
        loading ? 
          <div className="d-flex justify-center container-fluid h-100 align-items-center">
            <Spinner animation="border" variant="primary" />
          </div> : 
          <Offcanvas.Body id="cuerpo-nav-producto">
            <li title="De línea" id="navs__drop-nav-product-linea">
              <button
              >
                De línea
              </button>
                <div id="products-linea">
                  <ul>
                    {sortAndFilterProducts(products, PRODUCTO_LINEA)?.map(
                      (product, index) => (
                          <ProductLiNav key={index}  product={product} />
                        )
                    )}
                  </ul>
                </div>
            </li>
            <li title="Especiales" id="navs__drop-nav-product-special">
              <button>
                Especiales
              </button>
                <div id="products-special">
                  <ul>
                    {sortAndFilterProducts(products, PRODUCTO_ESPECIAL).map(
                      (product, index) => (
                          <ProductLiNav key={index} product={product} />
                        )
                    )}
                  </ul>
                </div>
            </li>
          </Offcanvas.Body>
      }
    </Offcanvas>
  )
}

export default OffcanvasProducts